import { Action } from '@ngrx/store';
import { TaskInterface } from 'app/task/models/task.model';

import { TaskActionType } from './task-action-type.enum';


export class UpdateTask implements Action {
  public readonly type: TaskActionType = TaskActionType.UpdateTask;

  constructor(public readonly payload: TaskInterface) { }
}

export class UpdateTaskCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.UpdateTaskCompleted;

  constructor(public readonly payload: TaskInterface) { }
}

export class UpdateTaskFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.UpdateTaskFailed;

  constructor(public readonly payload: string) { }
}
